export default "__VITE_ASSET__CzCxPOhZ__"